import React from 'react';
import UnAuthorized from '../../pages/authentication/UnAuthorized';
import { hasPermission } from './authorizeNavigation';
import ComponentNavigation from '../../navigation/ComponentNavigation';
import { useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {

    const location = useLocation();

    // Extract the last segment of the pathname as routhPath
    let routhPath = location.pathname.replace("/", "");
    const segments = location.pathname.split("/");
    if (segments.length > 1) {
        routhPath = segments[1];
    }


    // Find the matching route based on routhPath
    const renderComponent = ComponentNavigation?.find((route) => route.id.toLowerCase() === routhPath.toLowerCase());

    // Check if the user is authorized to access the current route
    const isAuthorized = renderComponent?.securityKey ? hasPermission(renderComponent.securityKey) : false;

    // Render content based on authorization status
    return isAuthorized ? (
        children
    ) : (
        <></>
        // <UnAuthorized />
    );
};

export default ProtectedRoute;
